export const galleryCategories = [
  { id: "all", name: "All Photos" },
  { id: "ice-cream", name: "Ice Cream" },
  { id: "shakes", name: "Shakes & Faluda" },
  { id: "desserts", name: "Rabdi & Desserts" },
  { id: "moments", name: "Shop & Moments" },
];

export const galleryItems = [
  {
    id: "g1",
    category: "ice-cream",
    title: "Kesar Pista Natural Ice Cream",
    description: "Infused with saffron strands & roasted pistachios",
    image: "https://images.unsplash.com/photo-1560008581-09826d1de69e?w=800&auto=format&fit=crop&q=85",
    aspect: "aspect-[4/5]",
  },
  {
    id: "g2",
    category: "ice-cream",
    title: "Seasonal Fresh Mango Scoop",
    description: "Crafted with 100% pure Alphonso mango pulp",
    image: "https://images.unsplash.com/photo-1501443762994-82bd5dace89a?w=800&auto=format&fit=crop&q=85",
    aspect: "aspect-square",
  },
  {
    id: "g3",
    category: "shakes",
    title: "Decadent Oreo & Chocolate Shake",
    description: "Thick, creamy and loaded with crunchy cookies",
    image: "https://images.unsplash.com/photo-1541658016709-82535e94bc69?w=800&auto=format&fit=crop&q=85",
    aspect: "aspect-[3/4]",
  },
  {
    id: "g4",
    category: "desserts",
    title: "Traditional Malai Rabdi with Ice Cream",
    description: "Slow-simmered rich creamy rabdi with cold vanilla",
    image: "https://images.unsplash.com/photo-1571115764595-644a1f56a55c?w=800&auto=format&fit=crop&q=85",
    aspect: "aspect-square",
  },
  {
    id: "g5",
    category: "shakes",
    title: "Royal Saffron Falooda",
    description: "Layered with vermicelli, basil seeds & natural kulfi",
    image: "https://images.unsplash.com/photo-1605112013730-7b6cc0c5a0b6?w=800&auto=format&fit=crop&q=85",
    aspect: "aspect-[4/5]",
  },
  {
    id: "g6",
    category: "ice-cream",
    title: "Fresh Strawberry Scoop",
    description: "Crushed farm strawberries with rich buffalo milk",
    image: "https://images.unsplash.com/photo-1633933358116-a27b902fad35?w=800&auto=format&fit=crop&q=85",
    aspect: "aspect-square",
  },
  {
    id: "g7",
    category: "ice-cream",
    title: "Creamy Caramel Butterscotch",
    description: "Sweet praline crunch inside creamy natural butterscotch",
    image: "https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?w=800&auto=format&fit=crop&q=85",
    aspect: "aspect-[3/4]",
  },
  {
    id: "g8",
    category: "moments",
    title: "Handcrafted In Udaipur",
    description: "Freshly made daily in small batches with love",
    image: "https://images.unsplash.com/photo-1551024506-0bccd828d307?w=800&auto=format&fit=crop&q=85",
    aspect: "aspect-[4/5]",
  },
  {
    id: "g9",
    category: "moments",
    title: "Waffle Cones Baked Fresh",
    description: "Crispy, golden waffle cones prepared daily in store",
    image: "https://images.unsplash.com/photo-1488900128323-21503983a07e?w=800&auto=format&fit=crop&q=85",
    aspect: "aspect-square",
  },
];
